module.exports = __webpack_public_path__ + "static/media/profile_background.866cc3ca.jpg";